import React, { useEffect, useMemo, useState } from 'react';
import * as R from 'ramda';
import $ from 'jquery';

import Emptylustration from './../../../assets/images/svg//057-contract-1.svg';

export const PaySummary = ({ invoices, partner, etablissement }) => {

	// const invoices = [1, 2, 3];
	const [linesToDisplay, setLinesToDisplay] = useState([]);
	const [collapse, setCollapse] = useState(true);
	const [filters, setFilters] = useState({
		order: {
			column: "number",
			asc: true
		},

	});

	const invoiceSum = useMemo(() => !R.isNil(invoices) ? invoices.reduce((acc, line) => { acc += line.amount; return acc; }, 0) : 0, [invoices]);
	const options = { style: 'currency', currency: 'EUR' };
	useEffect(() => {

		if (!R.isNil(invoices)) {

			let temp = invoices.filter(i => i.totalPrice !== 0);

			if (filters.order.asc) {

				temp = R.sort(R.ascend(R.prop(filters.order.column)), temp);

			} else {

				temp = R.sort(R.descend(R.prop(filters.order.column)), temp);

			}

			setLinesToDisplay(temp);
		}


	}, [filters, invoices]);

	return (
		<div className="modal fade px-0" id="paySummary" aria-labelledby="paySummaryLabel" aria-hidden="true">
			<div className="modal-dialog px-2">
				<div className="modal-content">
					<header className="modal-header pb-0">
						<div className="alert bg-alert-info rounded-bottom-right-sm rounded-top-left-sm w-100 text-center mb-0">
							<h1 className="sr-only visually-hidden">Payment summary</h1>
							<div className="flex-row align-items-center justify-content-between">
								<div className="h4 text-info text-uppercase mb-0 font-weight-bolder ls-n1 lh-1 mx-auto" id="paySummaryLabel">Information du paiement</div>
								<button type="button" className="btn btn-close btn-icon p-0 mr-0" data-dismiss="modal" aria-label="Close">
									<i className="eva eva-close fs-4"></i>
								</button>
							</div>
						</div>
					</header>
					<div className="modal-body">
						{!R.isNil(partner) ? <div className="fs-3 o-60">Partenaire:  <strong>{partner.name}</strong>  <i className="eva eva-chevron-right-outline align-middle mx-2 o-50"></i>Établissement: <strong>{!R.isNil(etablissement) ? etablissement.name : "--"}</strong> </div> : null}
						{!R.isEmpty(invoices) ?
							<div className="bg-light rounded mt-4 p-3">
								<section className="block">
									<div className="flex-row justify-content-between align-items-center mb-2 d-lg-none">
										<h3 className="h6 text-uppercase font-weight-bold mr-2 my-auto">A Payer</h3>
										<button className="btn-icon btn-alert bg-white navbar-toggler border-0 ml-auto rounded-max px-1" type="button" data-toggle="collapse" data-target="#trierPayer" aria-controls="trierPayer" aria-expanded="false" aria-label="Toggle navigation">
											<span className="btn-alert-primary eva eva-funnel-outline rounded-inherit my-auto lh-1 fs-sm p-1"></span>
											<span className="text-gray h6 lh-1 my-auto ml-2 mr-3">Trier par</span>
										</button>
									</div>

									<article className="block">
										<nav className="navbar navbar-expand-lg collapse navbar-collapse py-0 px-2 mb-xs show" id="trierPayer">
											<div className="flex-column w-100">
												<div className="row g-1 gy-lg-0 align-items-center">
													<div className="col flex-row" onClick={(e) => setFilters({ ...filters, order: { column: "number", asc: filters.order.column === "number" ? !filters.order.asc : true } })}>
														<div className="flex-column mr-1">
															<button className={"btn btn-item btn-icon fs-3 font-weight-bold ls-1 my-auto no-outline" + (filters.order.column === "number" && filters.order.asc ? "" : " o-50 o-100--hover")} type="button">
																<i className="eva eva-arrow-up fs-2 lh-0"></i>
															</button>
															<button className={"btn btn-item btn-icon fs-3 font-weight-bold ls-1 my-auto no-outline" + (filters.order.column === "number" && !filters.order.asc ? "" : " o-50 o-100--hover")} type="button">
																<i className="eva eva-arrow-down fs-2 lh-0"></i>
															</button>
														</div>
														<div className={"btn btn-item rounded-0 fs-3 font-weight-bold ls-1 my-auto text-truncate" + (filters.order.column === "number" ? " text-primary" : " ")}>Numéro</div>
													</div>
													<div className="col col-lg-3 flex-row" onClick={(e) => setFilters({ ...filters, order: { column: "created", asc: filters.order.column === "created" ? !filters.order.asc : true } })}>
														<div className="flex-column mr-1" >
															<button className={"btn btn-item btn-icon fs-3 font-weight-bold ls-1 my-auto no-outline" + (filters.order.column === "created" && filters.order.asc ? "" : " o-50 o-100--hover")} type="button">
																<i className="eva eva-arrow-up fs-2 lh-0"></i>
															</button>
															<button className={"btn btn-item btn-icon fs-3 font-weight-bold ls-1 my-auto no-outline" + (filters.order.column === "created" && !filters.order.asc ? "" : " o-50 o-100--hover")} type="button">
																<i className="eva eva-arrow-down fs-2 lh-0"></i>
															</button>
														</div>
														<div className={"btn btn-item rounded-0 fs-3 font-weight-bold ls-1 my-auto text-truncate" + (filters.order.column === "created" ? " text-primary" : " ")}>Date d'emission</div>
													</div>
													<div className="col flex-row " role="button" onClick={(e) => setFilters({ ...filters, order: { column: "amount", asc: filters.order.column === "amount" ? !filters.order.asc : true } })}>
														<div className="flex-column mr-1">
															<button className={"btn btn-item btn-icon fs-3 font-weight-bold ls-1 my-auto no-outline" + (filters.order.column === "amount" && filters.order.asc ? "" : " o-50 o-100--hover")} type="button">
																<i className="eva eva-arrow-up fs-2 lh-0"></i>
															</button>
															<button className={"btn btn-item btn-icon fs-3 font-weight-bold ls-1 my-auto no-outline" + (filters.order.column === "amount" && !filters.order.asc ? "" : " o-50 o-100--hover")} type="button">
																<i className="eva eva-arrow-down fs-2 lh-0"></i>
															</button>
														</div>
														<div className={"btn btn-item rounded-0 fs-3 font-weight-bold ls-1 my-auto text-truncate container-tiny" + (filters.order.column === "amount" ? " text-primary" : " ")}>Montant <span className="d-lg-none d-xl-inline-block"> Total</span></div>
													</div>
													<div className="col flex-row " role="button" >

													</div>


												</div>
											</div>
										</nav>
										{
											invoices?.map(invoice => (
												<div className="card p-2 mt-1" key={invoice.id}>
													<div className="row g-1 align-items-center">
														<div className="col col-lg-3 text-truncate">
															<div className="h5 ls-1 my-auto o-80 text-truncate">{invoice.number}</div>
														</div>
														<div className="col col-lg text-truncate  text-lg-left">
															<div className="h5 ls-1 my-auto text-truncate">{new Intl.DateTimeFormat('fr-FR').format(invoice.created)}</div>
														</div>

														<div className="col-12 d-lg-none">
															<hr className="my-0" />
														</div>
														<div className="col text-truncate text-left">
															<div className="h5 ls-1 my-auto text-truncate">{new Intl.NumberFormat('fr-FR', options).format(invoice.amount)}</div>
														</div>
														<div className="col col-lg text-truncate text-right text-lg-left py-0 d-flex align-items-center justify-content-end">
															{
																invoice.paid ?
																	<div className="badge alert-bagde text-uppercase btn-alert-success font-weight-bold my-auto py-2 px-3 lh-1 mr-auto mr-md-0 text-truncate">
																		<span className="aling-middle text-truncate">Payé</span>
																	</div>
																	:
																	<div className="badge alert-bagde text-uppercase btn-alert-danger font-weight-bold my-auto py-2 px-3 lh-1 mr-auto mr-md-0 text-truncate">
																		<span className="aling-middle text-truncate">A Payer</span>
																	</div>


															}
														</div>
													</div>
												</div>
											))
										}

										{/* <div className="card p-2 mt-1">
										<div className="row g-1 align-items-center">
											<div className="col col-lg-2 text-truncate">
												<div className="h5 ls-1 my-auto text-truncate">22/12/2021</div>
											</div>
											<div className="col col-lg text-truncate text-right text-lg-left">
												<div className="h5 ls-1 my-auto o-80 text-truncate">69</div>
											</div>
											<div className="col-12 d-lg-none">
												<hr className="my-0" />
											</div>
											<div className="col text-truncate text-right">
												<div className="h5 ls-1 my-auto text-truncate">formatAmount(invoice.amount) €</div>
											</div>
										</div>
									</div> */}
									</article>
									{/* <hr className="mb-2" /> */}
									{/* <div className="flex-row justify-content-between align-items-center">
										<h3 className="fs-3 font-weight-bold my-auto">Total</h3>
										<h4 className="h5 my-auto">{new Intl.NumberFormat('fr-FR', options).format(invoiceSum)}</h4>
									</div> */}
								</section>
							</div>
							:
							<section className="block text-center m-auto py-xs">
								<img className="img-fluid img-contain container-paper mx-auto mt-auto mb-3" src={Emptylustration} width={70} alt="Assist@" />
								<div className="block text-center container-thin mx-auto mb-auto">
									<h1 className="h1 font-weight-semi ls-n2 lh-1">On dirait <br></br> qu'il est vide.</h1>
									<p className="fs-aux o-80 mb-0">Il n'y a pas de facture.</p>
								</div>
							</section>
						}
					</div>
					<div className="modal-footer">
						<button type="button" className="btn btn-light" data-dismiss="modal" aria-label="Close">Fermer</button>
						<button type="button" className="btn btn-info">Ok</button>
					</div>
				</div>
			</div>
		</div>
	);
};